export class PostClosingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPostClosing({ loanId }) {
    return this.#http.get(`/loan/${loanId}/post-closing`);
  }

  async getSellSideLock({ loanId }) {
    return this.#http.get(`/loan/${loanId}/sell-side-lock`);
  }

  async editPostClosing({ loanId, ...body }) {
    return this.#http.put(`/loan/${loanId}/post-closing`, body);
  }
}
